// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const IdLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.idLabel" description="Id label." defaultMessage="ID" />
);
IdLabel.displayName = "IdLabel";

export const VersionLabel = (props: { version: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.versionLabel"
        description="Version label."
        defaultMessage="Version {version}"
        values={props}
    />
);
VersionLabel.displayName = "VersionLabel";

export const IdTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.idTooltip"
        description="Id tooltip."
        defaultMessage="ID of the spec (auto-generated)"
    />
);
IdTooltip.displayName = "IdTooltip";

export const NameLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.nameLabel" description="Name label." defaultMessage="Name" />
);
NameLabel.displayName = "NameLabel";

export const NameTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.nameTooltip"
        description="Name tooltip."
        defaultMessage="Human readable name that appears in Lens Studio API Library."
    />
);
NameTooltip.displayName = "NameTooltip";

export const ProviderLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.providerLabel" description="Provider label." defaultMessage="Provider" />
);
ProviderLabel.displayName = "ProviderLabel";

export const ProviderTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.providerTooltip"
        description="Provider tooltip."
        defaultMessage="A human readable name that described who the third party is that owns this API. This will be displayed in Lens Studio."
    />
);
ProviderTooltip.displayName = "ProviderTooltip";

export const DocumentationUrlLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.documentationUrlLabel"
        description="Documentation url label."
        defaultMessage="Documentation Link (Optional)"
    />
);
DocumentationUrlLabel.displayName = "DocumentationUrlLabel";

export const DocumentationUrlTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.documentationUrlTooltip"
        description="Documentation url tooltip."
        defaultMessage="Please provide a URL to publicly accessible documentation for this API. Format of: https://example.com/doc"
    />
);
DocumentationUrlTooltip.displayName = "DocumentationUrlTooltip";

export const DocumentationUrlReadTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.documentationUrlReadTooltip"
        description="Documentation url read tooltip."
        defaultMessage="URL to publicly accessible documentation for this API."
    />
);
DocumentationUrlReadTooltip.displayName = "DocumentationUrlReadTooltip";

export const IconUrlLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.iconUrlLabel"
        description="Icon url label."
        defaultMessage="Icon URL (Optional)"
    />
);
IconUrlLabel.displayName = "IconUrlLabel";

export const IconUrlTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.iconUrlTooltip"
        description="Icon url tooltip."
        defaultMessage="Please provide an icon image URL for this API. Format of: https://example.com/vacation.jpg"
    />
);
IconUrlTooltip.displayName = "IconUrlTooltip";

export const IconUrlReadTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.iconUrlReadTooltip"
        description="Icon url read tooltip."
        defaultMessage="Icon image URL for this API"
    />
);
IconUrlReadTooltip.displayName = "IconUrlReadTooltip";

export const DescriptionLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.descriptionLabel"
        description="Description label."
        defaultMessage="Description"
    />
);
DescriptionLabel.displayName = "DescriptionLabel";

export const DescriptionTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.descriptionTooltip"
        description="Description tooltip."
        defaultMessage="Human readable description of this API. This will be displayed in Lens Studio."
    />
);
DescriptionTooltip.displayName = "DescriptionTooltip";

export const TargetPlatformsLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.targetPlatformsLabel"
        description="Target platforms label."
        defaultMessage="Target Platforms"
    />
);
TargetPlatformsLabel.displayName = "TargetPlatformsLabel";

export const TargetPlatformsReadTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.targetPlatformsReadTooltip"
        description="Target platforms read tooltip."
        defaultMessage="The platform in which this Lens runs on. Spectacles for Snap hardware wearables, Camera Kit for third party platforms, and Snapchat for Snapchat app."
    />
);
TargetPlatformsReadTooltip.displayName = "TargetPlatformsReadTooltip";

export const TargetPlatformsUpdateTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.targetPlatformsUpdateTooltip"
        description="Target platforms update tooltip."
        defaultMessage="Please select the platform in which you wish this Lens to run on. Select Spectacles for Snap hardware wearables, Camera Kit for third party platforms, and Snapchat for Snapchat app."
    />
);
TargetPlatformsUpdateTooltip.displayName = "TargetPlatformsUpdateTooltip";

export const VisibilityLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.visibilityLabel"
        description="Visibility label."
        defaultMessage="Visibility"
    />
);
VisibilityLabel.displayName = "VisibilityLabel";

export const VisibilityTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.visibilityTooltip"
        description="Visibility tooltip."
        defaultMessage="All APIs will be set to private. Only the individual who submits the API will be able to see and utilize the API in a Lens from the API Library within the Lens Studio Asset Library. These APIs will not be accessible to other developers."
    />
);
VisibilityTooltip.displayName = "VisibilityTooltip";

export const MinLensStudioVersionLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.minLensStudioVersionLabel"
        description="Min lens studio version label."
        defaultMessage="Minimum Lens Studio Version (Optional)"
    />
);
MinLensStudioVersionLabel.displayName = "MinLensStudioVersionLabel";

export const MinLensStudioVersionTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.minLensStudioVersionTooltip"
        description="Min lens studio version tooltip."
        defaultMessage='Minimum Lens Studio version that this spec will be shown in. (e.g. "4.10.0.0")'
    />
);
MinLensStudioVersionTooltip.displayName = "MinLensStudioVersionTooltip";

export const CustomVisibilityUserListLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.customVisibilityUserListLabel"
        description="Custom visibility user list label."
        defaultMessage="Username Allowlist (Camera Kit Only)"
    />
);
CustomVisibilityUserListLabel.displayName = "CustomVisibilityUserListLabel";

export const CustomVisibilityUserListTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.customVisibilityUserListTooltip"
        description="Custom visibility user list tooltip."
        defaultMessage="Provide the Snapchat usernames of lens developers to allow them to import this Remote API specification into Lens Studio."
    />
);
CustomVisibilityUserListTooltip.displayName = "CustomVisibilityUserListTooltip";

export const SnapkitAppIdLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.snapkitAppIdLabel"
        description="Snapkit app id label."
        defaultMessage="Snap Kit App ID (Camera Kit Only)"
    />
);
SnapkitAppIdLabel.displayName = "SnapkitAppIdLabel";

export const SnapkitAppIdTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.snapkitAppIdTooltip"
        description="Snapkit app id tooltip."
        defaultMessage="Find this in the Developer Portal > Setup tab under your app's name"
    />
);
SnapkitAppIdTooltip.displayName = "SnapkitAppIdTooltip";

export const ProcessorLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.processorLabel"
        description="Processor label."
        defaultMessage="Request Processor (Camera Kit Only)"
    />
);
ProcessorLabel.displayName = "ProcessorLabel";

export const ProvidedProcessorLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.providedProcessorLabel"
        description="Provided processor label."
        defaultMessage="Provided Processor"
    />
);
ProvidedProcessorLabel.displayName = "ProvidedProcessorLabel";

export const ProvidedProcessorTooltip = (): ReactElement => (
    <>
        {" "}
        <FormattedMessage
            id="apps.apis.components.providedProcessorTooltip"
            description="Provided processor tooltip."
            defaultMessage="Provided Processor will automatically forward the request to the external service outlined in this API spec."
        />
        <br />{" "}
        <FormattedMessage
            id="apps.apis.components.providedProcessorTooltip"
            description="Provided processor tooltip."
            defaultMessage='Note: "Provided Processor" is supported starting with Lens Studio 5.4, Mobile SDKs 1.37, and Web SDK 1.1.0.'
        />
        <br />{" "}
        <FormattedMessage
            id="apps.apis.components.providedProcessorTooltip"
            description="Provided processor tooltip."
            defaultMessage="Ensure you are using the correct versions for this feature to work."
        />
    </>
);
ProvidedProcessorTooltip.displayName = "ProvidedProcessorTooltip";

export const CustomProcessorLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.customProcessorLabel"
        description="Custom processor label."
        defaultMessage="Custom Processor"
    />
);
CustomProcessorLabel.displayName = "CustomProcessorLabel";

export const CustomProcessorTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.customProcessorTooltip"
        description="Custom processor tooltip."
        defaultMessage="Custom Processor should be selected to send requests to the Camera Kit host app / site."
    />
);
CustomProcessorTooltip.displayName = "CustomProcessorTooltip";

export const HostLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.hostLabel" description="Host label." defaultMessage="Host" />
);
HostLabel.displayName = "HostLabel";

export const HostTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.hostTooltip"
        description="Host tooltip."
        defaultMessage='Hostname of the API, without https://, e.g. "api.example.com"'
    />
);
HostTooltip.displayName = "HostTooltip";

export const MaxRequestSizeLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.maxRequestSizeLabel"
        description="Max request size label."
        defaultMessage="Max request size (bytes, optional)"
    />
);
MaxRequestSizeLabel.displayName = "MaxRequestSizeLabel";

export const MaxRequestSizeTootip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.maxRequestSizeTootip"
        description="Max request size tootip."
        defaultMessage="Default value: 1000 bytes"
    />
);
MaxRequestSizeTootip.displayName = "MaxRequestSizeTootip";

export const MaxResponseSizeLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.maxResponseSizeLabel"
        description="Max response size label."
        defaultMessage="Max response size (bytes, optional)"
    />
);
MaxResponseSizeLabel.displayName = "MaxResponseSizeLabel";

export const MaxResponseSizeTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.maxResponseSizeTooltip"
        description="Max response size tooltip."
        defaultMessage="Max response size (bytes, optional)"
    />
);
MaxResponseSizeTooltip.displayName = "MaxResponseSizeTooltip";

export const MaxResponseTimeLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.maxResponseTimeLabel"
        description="Max response time label."
        defaultMessage="Max response time (milliseconds, optional)"
    />
);
MaxResponseTimeLabel.displayName = "MaxResponseTimeLabel";

export const MaxResponseTimeTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.maxResponseTimeTooltip"
        description="Max response time tooltip."
        defaultMessage="Default value: 3000ms"
    />
);
MaxResponseTimeTooltip.displayName = "MaxResponseTimeTooltip";

export const TermsOfServiceTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.termsOfServiceTitle"
        description="Terms of service title."
        defaultMessage="Terms of Service"
    />
);
TermsOfServiceTitle.displayName = "TermsOfServiceTitle";

export const GuidelinesTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.guidelinesTitle"
        description="Guidelines title."
        defaultMessage="Community Guidelines"
    />
);
GuidelinesTitle.displayName = "GuidelinesTitle";

export const TermsAndConditions1 = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.termsAndConditions1"
        description="Terms and conditions1."
        defaultMessage="By checking the box, you confirm that you have agreed to the "
    />
);
TermsAndConditions1.displayName = "TermsAndConditions1";

export const TermsAndConditions2 = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.termsAndConditions2"
        description="Terms and conditions2."
        defaultMessage=" and "
    />
);
TermsAndConditions2.displayName = "TermsAndConditions2";

export const TermsAndConditions3 = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.termsAndConditions3"
        description="Terms and conditions3."
        defaultMessage=", and agree not to upload any code that interferes with, disrupts or can damage the functioning of Snap’s Services, servers, systems, or data in any way"
    />
);
TermsAndConditions3.displayName = "TermsAndConditions3";

export const CustomVisibilityUserListButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.customVisibilityUserListButtonCta"
        description="Custom visibility user list button cta."
        defaultMessage="Add User"
    />
);
CustomVisibilityUserListButtonCta.displayName = "CustomVisibilityUserListButtonCta";

export const CopyButtonCta = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.copyButtonCta" description="Copy button cta." defaultMessage="Copy" />
);
CopyButtonCta.displayName = "CopyButtonCta";

export const UpdateButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.updateButtonCta"
        description="Update button cta."
        defaultMessage="Update API"
    />
);
UpdateButtonCta.displayName = "UpdateButtonCta";

export const CancelButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.cancelButtonCta"
        description="Cancel button cta."
        defaultMessage="Cancel"
    />
);
CancelButtonCta.displayName = "CancelButtonCta";

export const EditButtonCta = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.editButtonCta" description="Edit button cta." defaultMessage="Edit" />
);
EditButtonCta.displayName = "EditButtonCta";

export const MyApisTitle = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.myApisTitle" description="My apis title." defaultMessage="My APIs" />
);
MyApisTitle.displayName = "MyApisTitle";

export const AddApiButtonCta = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.addApiButtonCta"
        description="Add api button cta."
        defaultMessage="Add API"
    />
);
AddApiButtonCta.displayName = "AddApiButtonCta";

export const StatusLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.statusLabel" description="Status label." defaultMessage="Status" />
);
StatusLabel.displayName = "StatusLabel";

export const DateModifiedLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.apis.components.dateModifiedLabel"
        description="Date modified label."
        defaultMessage="Date Modified"
    />
);
DateModifiedLabel.displayName = "DateModifiedLabel";

export const AllLabel = (): ReactElement => (
    <FormattedMessage id="apps.apis.components.allLabel" description="All label." defaultMessage="All" />
);
AllLabel.displayName = "AllLabel";

export const messages = defineMessages({
    descriptionPlaceholder: {
        id: "apps.apis.components.descriptionPlaceholder",
        description: "Description placeholder.",
        defaultMessage: "API Description (HTML allowed)",
    },
    targetPlatformsSelectPlaceholder: {
        id: "apps.apis.components.targetPlatformsSelectPlaceholder",
        description: "Target platforms select placeholder.",
        defaultMessage: "Select target platforms...",
    },
});
